export default __webpack_public_path__ + "static/media/pic1.d8c3c8e3.jpg";